import { InjectionToken } from "@angular/core";
import * as Models from '../../models/public_api';
import { Observable } from "rxjs";
import { KeyValue } from "@angular/common";
import { IInvestorTypeCommit, ISignerOfAgreement, SubscriptionStatus } from "../../models/public_api";

export const IINVEST_SERVICE = new InjectionToken<IInvestRequestService>(
  "investorRequest"
);

export interface IInvestRequestService {
  isAllAuditRequestComplete(): boolean;
  getInvestItemListForCurrentUser(): Observable<Models.InvesterItem[]>;
  getTaskItemListForCurrentUser(): Observable<Models.TaskItem[]>;
  getFundItemListForCurrentUser(): Observable<Models.FundItem[]>;
  getInvestItemListByFundIdForCurrentUser(fundIdList: number[]): Observable<Models.InvesterItem[]>;
  getTaskItemListByFundIdForCurrentUser(fundIdList: number[]): Observable<Models.TaskItem[]>;

  getSubscriptionFillListBySubscriptionId(subscriptionId: number): Observable<Models.ValidatableModel[]>;
  //createSignAgreement(signInfo: { DealRelationshipId: number, ContactId: number, ManagerId: number, AnswerList: { Id: number, Answer: string }[] }): Observable<string>;
  // getSignView(signInfo: { DealRelationshipId: number, ContactId: number, ManagerId: number, AnswerList: { Id: number, Answer: string }[] }): Observable<string>;
  // previewAgreement(DealRelationshipId: number): Observable<Blob>;

  getInvestorTypeInfoByAccountId(onboardingAccountId: number): Observable<Models.IInvestorTypeSelectViewModel>;
  saveInvestorTypeInfoForInvestor(param: IInvestorTypeCommit): Observable<boolean>;
  changeInvestorType(param: IInvestorTypeCommit): Observable<boolean>;

  getInvestorStepsForOnboardingAccount(onboardingAccountId: number): Observable<Models.IInvestorStepViewModel>;
  getInvestorStepsForPilotTesting(investorTypeId: number): Observable<Models.IInvestorStepViewModel>;
  resetWizardStep(onboardingAccountId: number): Observable<boolean>;
  commitInvestorSteps(commit: Models.IInvestorCommit): Observable<boolean>;
  savingCurrentWork(commit: Models.IInvestorCommit);
  resetAuditRequestQueue();
  commitInvestorStepsAndRequestPreview(commit: Models.IInvestorCommit): Observable<{ envelopeId: string, isCurrentUserCanSign: boolean, signerListArray: Models.ISignerOfAgreement[], signUrl: string }>;
  invokeSignWorflow(envelopId: string, signer: Models.ISignerOfAgreement, onboardingAccountId: number): Observable<string>;
  commitSignerAndSendEmail(onboardingAccountId: number, showSpin?: boolean): Observable<SubscriptionStatus>;
  releaseOnboardingLock(onboardingAccountId: number): Observable<void>;
  commitAnswerOfQuestionAndUpdateStatus(commit: Models.IInvestorCommit, showLoading?: boolean): Observable<SubscriptionStatus>;
  destoryAgreement(onboardingAccountId: number);
  getAgreementPreview(url: string);
  getFieldPages(onboardingAccountId: number): Observable<number[]>;
  revokeSubscription(accountId: number): Observable<any>;
  uploadAgreementAndMakeDocusignTemplateForPilotTest(files: FormData, pilotTestCaseId: number, fundId: number): Observable<ISignerOfAgreement[]>;
  uploadFilledAgreementAndUpdateStatus(onboardingAccountId: number, file: File, commit: Models.IInvestorCommit): Observable<SubscriptionStatus>;
}
